'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage(kind) {
  this.M5 = null;
  this.M5 = kind;
}
export { $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage as $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage };
$p = $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage;
/** @constructor */
function $h_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage() {
}
export { $h_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage as $h_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage };
$h_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage)) {
    var x = this.M5;
    var x$2 = x$0.M5;
    return (x === x$2);
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "ResourceDeletedWhileEditingPage";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.M5;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "kind";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ke)));
}
export { $isArrayOf_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage as $isArrayOf_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage };
var $d_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage, "app.pages.AppPage$ResourceDeletedWhileEditingPage", ({
  ke: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage as $d_Lapp_pages_AppPage$ResourceDeletedWhileEditingPage };
//# sourceMappingURL=app.pages.-App-Page$-Resource-Deleted-While-Editing-Page.js.map
